import { render } from "./TheLichNaoVetHoGa.vue?vue&type=template&id=7127d737"
import script from "./TheLichNaoVetHoGa.vue?vue&type=script&lang=js"
export * from "./TheLichNaoVetHoGa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__